module.exports = __webpack_public_path__ + "img/bg2.c41bf9b9.png";